import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import {
  Button, Card, Col, Form,
} from 'react-bootstrap';
import useAPI from '../hooks/useAPI';
import SelectWithCustomInput from './SelectWithCustomInput/SelectWithCustomInput';
import Required from './Required';
import useToast from '../hooks/useToast';
import { BaseRequests } from '../requests/BaseRequests';

function ReceiptEdit() {
  const api = useAPI();
  const headId = localStorage.getItem('headId');
  const institute = { value: '', label: localStorage.getItem('headInstitute') };
  const topic = localStorage.getItem('topic');
  const [teamMembers, setTeamMembers] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [selectedHead, setSelectedHead] = useState({});
  const [selectedInstitute, setSelectedInstitute] = useState({});
  const { projId, receiptId } = useParams();
  const [searchInstitute, setSearchInstitute] = useState('');
  const [topicName, setTopicName] = useState(topic);
  const [searchHeadValue, setSearchHeadValue] = useState('');
  const history = useHistory();
  const addToast = useToast();

  useEffect(async () => {
    const resp = await api.get(
      BaseRequests.getUrlSearch('/factdata/teammembers', { projId }),
    );
    const inst = await api.get('/structure/institutes');
    setTeamMembers(resp?.data.filter((value) => value.status === 'approved').map((value) => ({
      label: `${value.lastName} ${value.firstName} ${value.middleName} (${value.post})`,
      value,
    })));
    setInstitutes(inst.map((e) => ({
      label: e.title,
      value: e.id,
    })));
  }, []);

  useEffect(async () => {
    setSelectedHead((teamMembers.find((e) => String(e.value.id) === headId)));
  }, [teamMembers]);

  const handleEditField = (event) => {
    setSelectedHead(event);
  };

  const removeStorage = () => {
    localStorage.removeItem('topic');
    localStorage.removeItem('headId');
    localStorage.removeItem('headInstitute');
  };

  const handleSave = async () => {
    const result = await api.post(`/factdata/contracts/0/pa/${receiptId}`, {
      projId,
      contractPAId: receiptId,
      topic: topicName,
      personsInCharge: [{
        id: selectedHead.value.id,
        institute: selectedInstitute.label,
      }],
    });
    result.hasOwnProperty('error')
      ? addToast.error(result.error.message)
      : (
        addToast.success('Поступление отредактировано'),
        history.push(`${history.location.pathname.split('/receipt')[0]}/receipts`),
        removeStorage()
      );
  };

  return (
    <div>
      <h3 style={{ color: 'black', margin: '20px 0 36px', textAlign: 'start' }}>Редактирование карточки поступления</h3>
      <div>
        <Card style={{ marginBottom: '20px' }}>
          <Card.Body style={{
            padding: '30px 25px', display: 'flex', flexDirection: 'column', rowGap: '24px',
          }}
          >
            <Form.Group as={Col}>
              <Form.Label style={{ color: '#7F7F7F' }}>
                Наименование темы
                <Required />
              </Form.Label>
              <Form.Control
                as="input"
                required
                name="topic"
                value={topicName}
                onChange={(event) => setTopicName(event.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label style={{ color: '#7F7F7F' }}>
                Руководитель темы
                <Required />
              </Form.Label>
              <Select
                placeholder="Выберите из списка участников проекта"
                options={teamMembers}
                value={selectedHead}
                onChange={(event) => handleEditField(event)}
                onInputChange={(selectedValue) => {
                  setSearchHeadValue(selectedValue);
                }}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <SelectWithCustomInput
                label="Институт (где работает руководитель темы)"
                placeholder="Выберите институт из списка или введите свое значение."
                defaultOptions={institutes}
                defaultValue={institute}
                onInputChange={(selectedValue) => {
                  setSearchInstitute(selectedValue);
                }}
                onChange={(val) => setSelectedInstitute(val)}
              />
            </Form.Group>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body style={{ display: 'flex', columnGap: '8px', padding: '30px 25px' }}>
            <Button
              onClick={() => {
                new Promise((resolve) => {
                  resolve(history.goBack());
                })
                  .then(() => {
                    removeStorage();
                  });
              }}
              type="button"
              variant="outline-secondary"
            >
              Отменить
            </Button>
            <Button type="submit" onClick={handleSave} variant="outline-primary">Сохранить</Button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default ReceiptEdit;
